import BaseCommand from "@/models/api/commands/BaseCommand";

export interface AddOwnerParams {
  Id: number;
  Share: number;
  OwnerType: number;
  Name: string;
}

export class AddOwnerCommand extends BaseCommand {
  CommandName = "AddOwner";
  Command: AddOwnerParams;
  constructor(sessionId: string, operationId: string, params: AddOwnerParams) {
    super(sessionId, operationId);
    this.Command = params;
  }
}
